import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Award } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const CertificationsModal = ({ isOpen, onClose, certifications }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Certifications</DialogTitle>
          <DialogDescription className="text-slate-400">
            Continuous learning and professional development
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="grid md:grid-cols-2 gap-6">
            {certifications.map((cert, index) => (
              <Card key={index} className="bg-slate-900 border-slate-800 p-6">
                <div className="flex items-start gap-3 mb-3">
                  <Award className="text-yellow-500 flex-shrink-0" size={24} />
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1 leading-tight">{cert.name}</h3>
                    <p className="text-blue-400 text-sm font-medium">{cert.issuer}</p>
                  </div>
                </div>
                <Badge variant="secondary" className="bg-blue-950 text-blue-400 border-blue-800">
                  {cert.year}
                </Badge>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default CertificationsModal;
